// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCommonUpdate } from "@ces/App/Handlers/XNG/Common";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadSession from "@insite/client-framework/Store/Context/Handlers/LoadSession";

type HandlerType = ApiHandler<{
    errorMessage: string;
}>;

export const CheckSessionTimeout: HandlerType = props => {
    if (!props.parameter.errorMessage.includes("session")) {
        return;
    }

    props.dispatch(
        loadSession({
            onComplete: (resultProps: any) => {
                if (resultProps?.apiResult?.isAuthenticated) {
                    return;
                }

                props.dispatch(
                    xCommonUpdate({
                        key: "redirectToSignInSessionTimeoutMessage",
                        value: props.parameter.errorMessage,
                    }),
                );
            },
        }),
    );
};

export const chain = [CheckSessionTimeout];

const redirectToSignInSessionTimeout = createHandlerChainRunner(chain, "redirectToSignInSessionTimeout");

export default redirectToSignInSessionTimeout;
